import request from '@/utils/request'

export const urlApi = {
  getDepartmentByLevel: '/index/common/Option/getDepartmentByLevel',
  getDepartmentList: '/index/common/Option/getDepartmentList',
  getPositionList: '/index/common/Option/getPositionList',
  getMenuList: '/index/common/Option/getMenuList',
  uploadImage: '/index/common/Upload/uploadImage',
  uploadVideo: '/index/common/Upload/uploadVideo',
  uploadVoice: '/index/common/Upload/uploadVoice',
  dictDataList: '/index/common/Option/getDictDataList',
  dataTableList: '/index/common/Option/dataTableList',
  getBreedByLevel: '/index/common/Option/getBreedByLevel',
  getCategoryByLevel: '/index/common/Option/getCategoryByLevel',
  getCommentByLevel: '/index/common/Option/getCommentByLevel',
  getAreaByLevel: '/index/common/Option/getAreaByLevel',
  updateContentPub: '/index/common/Option/updateContentPub',
  goodsCategory: '/index/common/Option/getGoodsCategory',
  goodsService: '/index/common/Option/getGoodsService',
  getReasonOption: '/index/common/Option/getReasonOption',
  onshelfMall: '/index/common/Option/onshelfMall',
  onshelfCustomer: '/index/common/Option/onshelfCustomer',
  expressTemplate: '/index/common/Option/getTradeExpressTemplate',
  getTags: '/index/common/Option/getTags',
  integralRule: '/index/common/Option/integralRule',
  getPetBreed: '/index/common/Option/getPetBreed'
}
/**
 * 获取投诉原因
 * @returns {*}
 * @param parameter 参数{reason_type:1} 1、投诉原因；2、退款原因
 */
export function reasonOption (parameter) {
  return request({
    url: urlApi.onshelfMall,
    method: 'post',
    data: parameter
  })
}

/**
 * 商城内容上下架
 * @returns {*}
 * @param parameter 参数{id:1,type:1,is_public:1}
 */
export function onshelfMall (parameter) {
  return request({
    url: urlApi.onshelfMall,
    method: 'post',
    data: parameter
  })
}

/**
 * 客户内容上下架
 * @returns {*}
 * @param parameter 参数参数{id:1,type:1,state:1}
 */
export function onshelfCustomer (parameter) {
  return request({
    url: urlApi.onshelfCustomer,
    method: 'post',
    data: parameter
  })
}
/**
 * 商品服务
 * @returns {*}
 */
export function goodsService () {
  return request({
    url: urlApi.goodsService,
    method: 'get',
  })
}
/**
 * 商品分类
 * @returns {*}
 */
export function goodsCategory () {
  return request({
    url: urlApi.goodsCategory,
    method: 'get',
  })
}

/**
 * 运费模版
 * @returns {*}
 */
export function TradeExpressTemplate () {
  return request({
    url: urlApi.expressTemplate,
    method: 'get'
  })
}

/**
 * 修改内容发布状态
 * @returns {*}
 * type 1、视频；2、文章；3、问题；4、回答
 * is_public 1、上架；2、下架
 * @param parameter 参数{id:1,type:1,is_public:1}
 */
export function updateContentPub (parameter) {
  return request({
    url: urlApi.updateContentPub,
    method: 'post',
    data: parameter
  })
}

/**
 * 根据等级查询评论
 * @returns {*}
 * @param parameter 参数{level:1}
 */
export function getCommentByLevel (parameter) {
  return request({
    url: urlApi.getCommentByLevel,
    method: 'get',
    params: parameter
  })
}
/**
 * 根据父级编号查询地域
 * @returns {*}
 * @param parameter 参数{level:1}
 */
export function getAreaByLevel (parameter) {
  return request({
    url: urlApi.getAreaByLevel,
    method: 'get',
    params: parameter
  })
}
/**
 * 根据条件获取话题列表
 * @returns {*}
 * @param parameter 参数{p_id:0}
 */
export function getTags (parameter) {
  return request({
    url: urlApi.getTags,
    method: 'get',
    params: parameter
  })
}

/**
 * 根据父级编号查询分类
 * @returns {*}
 * @param parameter 参数{level:1}
 */
export function getCategoryByLevel (parameter) {
  return request({
    url: urlApi.getCategoryByLevel,
    method: 'get',
    params: parameter
  })
}

/**
 * 根据父级编号查询品种
 * @returns {*}
 * @param parameter 参数{level:1}
 */
export function getBreedByLevel (parameter) {
  return request({
    url: urlApi.getBreedByLevel,
    method: 'get',
    params: parameter
  })
}

/**
 * 根据字典类型获取字典数据
 * @returns {*}
 * @param parameter 参数{dict_type:'sys_user_sex'}
 */
export function getDictDataList (parameter) {
  return request({
    url: urlApi.dictDataList,
    method: 'get',
    params: parameter
  })
}

/**
 * 根据父级编号查询部门
 * @returns {*}
 * @param parameter 参数{p_id:0}
 */
export function getDepartmentByLevel (parameter) {
  return request({
    url: urlApi.getDepartmentByLevel,
    method: 'get',
    params: parameter
  })
}

/**
 * 获取部门列表
 * @returns {*}
 */
export function getDepartmentList () {
  return request({
    url: urlApi.getDepartmentList,
    method: 'get'
  })
}

/**
 * 获取获取职位列表
 * @returns {*}
 */
export function getPositionList () {
  return request({
    url: urlApi.getPositionList,
    method: 'get'
  })
}

/**
 * 获取部门列表
 * @returns {*}
 */
export function getMenuList () {
  return request({
    url: urlApi.getMenuList,
    method: 'get'
  })
}

/**
 * 获取数据列表
 * @returns {*}
 */
export function getDataTableList () {
  return request({
    url: urlApi.dataTableList,
    method: 'get'
  })
}

/**
 * 获取积分规则列表
 * @returns {*}
 */
export function getIntegralRule () {
  return request({
    url: urlApi.integralRule,
    method: 'get'
  })
}

/**
 *获取宠物品种
 * @returns {*}
 */
export function getPetBreed () {
  return request({
    url: urlApi.getPetBreed,
    method: 'get'
  })
}